import { useMemo } from 'react';
import { useApi2 } from 'containers/Api2/index.js';
import useCurrentRole from 'containers/User/useCurrentRole.js';
import { makeIdObject } from 'utils/arrays.js';
import enrichSet from './enrichSet.js';
import parseSet from './parseSet.js';

function useParentMeetingSets() {
  const meetingSets = useApi2({ url: 'meetings/sets/parents', selector: 'meetings/sets', parser: parseSet, noReport: [401] });
  const { connections } = useCurrentRole();

  const getSets = useMemo(() => {
    if (!meetingSets.list || !connections) {
      return meetingSets;
    }
    const students = makeIdObject(connections);
    const fullSets = { ...meetingSets };
    meetingSets.list?.forEach((id) => {
      fullSets[id] = enrichSet({ ...meetingSets[id], students });
    });
    return fullSets;
  }, [meetingSets, connections]);

  return getSets;
}

export default useParentMeetingSets;
